<script>
  import { business, menuDraft } from "../stores.js";
  import { createEventDispatcher, onMount, tick } from "svelte";
  import { pop } from "svelte-spa-router";
  import { itemNameTaken, menuItemCategories } from "../utils.js";
  import TiArrowSortedUp from "svelte-icons/ti/TiArrowSortedUp.svelte";
  import TiArrowSortedDown from "svelte-icons/ti/TiArrowSortedDown.svelte";

  const dispatch = createEventDispatcher();

  export let item;
  item.errors = {};

  export let mode; //edit or new

  //dom elements
  let nameInput;

  let hasErrors = false;

  function checkErrors() {
    hasErrors = false;
    if (item.errors?.name) {
      hasErrors = true;
    } else {
      //check options
      item.options.forEach((section) => {
        if (section.error) hasErrors = true;
        else
          section.items.find((item) => {
            if (item.errors) hasErrors = true;
          });
      });

      //check checkboxes
      item.checkboxes.forEach((section) => {
        if (section.error) hasErrors = true;
        else
          section.items.forEach((item) => {
            if (item.error) hasErrors = true;
          });
      });
    }
    item = item;
  }

  function validateName() {
    //check empty
    if (!item.name) {
      item.errors.name = "ריק";
    } else {
      // check if name exists
      let names = {};
      names[item.name.trim()] = true;

      if (itemNameTaken(item, mode, $menuDraft)) {
        item.errors.name = "שם קיים";
      } else {
        delete item.errors.name;
      }
    }
    checkErrors();
  }

  function validateLabel(option, optionsSection) {
    if (option.label == "") {
      option.error = "ריק";
    } else if (
      optionsSection.items.find((i) => i != option && i.label == option.label)
    ) {
      option.error = "שם קיים";
    } else {
      delete option.error;
    }
    checkErrors();
  }

  function validateOptionsName(optionsSection) {
    if (optionsSection.name == "") {
      optionsSection.error = "ריק";
    } else if (
      item.options.find((s) => {
        return s != optionsSection && optionsSection.name == s.name;
      })
    ) {
      optionsSection.error = "שם קיים";
    } else {
      delete optionsSection.error;
    }
    checkErrors();
  }

  function validateCheckboxesName(checkboxSection) {
    if (checkboxSection.name == "") {
      checkboxSection.error = "ריק";
    } else if (
      item.checkboxes.find((cb) => {
        return cb != checkboxSection && checkboxSection.name == cb.name;
      })
    ) {
      checkboxSection.error = "שם קיים";
    } else {
      delete checkboxSection.error;
    }
    checkErrors();
  }

  onMount(async () => {
    await tick();
    nameInput.select();
  });

  function addOption() {
    item.options = [
      ...item.options,
      { items: [{ label: "", priceVar: 0 }], name: "" },
    ];
  }

  function removeOption(idx) {
    item.options.splice(idx, 1);
    item.options = item.options; //svelte reactivity hook
  }

  function addOptionItem(sectionIdx) {
    item.options[sectionIdx].items = [
      ...item.options[sectionIdx].items,
      { label: "", priceVar: 0 },
    ];
  }

  function removeOptionItem(sectionIdx, itemIdx) {
    item.options[sectionIdx].items.splice(itemIdx, 1);
    item.options[sectionIdx].items = item.options[sectionIdx].items;
  }

  function addCheckboxSection() {
    item.checkboxes = [
      ...item.checkboxes,
      {
        name: "",
        items: [],
        maxSelect: 1,
      },
    ];
  }

  function removeCheckboxSection(idx) {
    item.checkboxes.splice(idx, 1);
    item.checkboxes = item.checkboxes;
  }

  function addCheckbox(idx) {
    item.checkboxes[idx].items = [
      ...item.checkboxes[idx].items,
      { label: "", priceVar: 0 },
    ];
  }

  function removeCheckbox(idx, checkboxIdx) {
    item.checkboxes[idx].items.splice(checkboxIdx, 1);
    item.checkboxes[idx].items = item.checkboxes[idx].items;
  }

  function validateAll() {
    validateName();
    item.options.forEach((section) => {
      validateOptionsName(section);
      section.items.forEach((option) => {
        validateLabel(option, section);
      });
    });

    item.checkboxes.forEach((section) => {
      validateCheckboxesName(section);
      section.items.forEach((checkbox) => {
        validateLabel(checkbox, section);
      });
    });

    checkErrors();
  }

  //move options
  function moveOptionsSectionUp(idx) {
    if (idx == 0) return;
    let temp = item.options[idx - 1];
    item.options[idx - 1] = item.options[idx];
    item.options[idx] = temp;
  }

  function moveOptionsSectionDown(idx) {
    if (idx == item.options.length - 1) return;
    let temp = item.options[idx + 1];
    item.options[idx + 1] = item.options[idx];
    item.options[idx] = temp;
  }

  function moveOptionUp(sectionIdx, idx) {
    if (idx == 0) return;
    let options = item.options[sectionIdx].items;
    let temp = options[idx - 1];
    options[idx - 1] = options[idx];
    options[idx] = temp;
    item = item;
  }

  function moveOptionDown(sectionIdx, idx) {
    let options = item.options[sectionIdx].items;
    if (idx == options.length - 1) return;
    let temp = options[idx + 1];
    options[idx + 1] = options[idx];
    options[idx] = temp;
    item = item;
  }

  //move checkboxes
  function moveCheckboxSectionUp(idx) {
    if (idx == 0) return;
    let temp = item.checkboxes[idx - 1];
    item.checkboxes[idx - 1] = item.checkboxes[idx];
    item.checkboxes[idx] = temp;
  }

  function moveCheckboxSectionDown(idx) {
    if (idx == item.checkboxes.length - 1) return;
    let temp = item.checkboxes[idx + 1];
    item.checkboxes[idx + 1] = item.checkboxes[idx];
    item.checkboxes[idx] = temp;
  }

  function moveCheckboxUp(sectionIdx, idx) {
    if (idx == 0) return;
    let checkboxes = item.checkboxes[sectionIdx].items;
    let temp = checkboxes[idx - 1];
    checkboxes[idx - 1] = checkboxes[idx];
    checkboxes[idx] = temp;
    item = item;
  }

  function moveCheckboxDown(sectionIdx, idx) {
    let checkboxes = item.checkboxes[sectionIdx].items;
    if (idx == checkboxes.length - 1) return;
    let temp = checkboxes[idx + 1];
    checkboxes[idx + 1] = checkboxes[idx];
    checkboxes[idx] = temp;
    item = item;
  }

</script>

<main>
  <div class="form" on:mousedown|stopPropagation>
    <div class="title">
      <input
        id="name"
        type="text"
        bind:this={nameInput}
        bind:value={item.name}
        on:input={validateName}
        class:error={item.errors?.name}
        selected
      />
      <input
        class="priceVar"
        id="price"
        type="number"
        min="1"
        bind:value={item.price}
      />
      <label for="price" class="curr">₪</label>
    </div>
    {#if item.errors?.name}
      <span class="errorLabel">{item.errors.name}</span>
    {/if}
    <input
      class="desc"
      type="text"
      bind:value={item.desc}
      placeholder="תיאור"
    />

    <div class="category">
      <label for="category">קטגוריה</label>

      <select name="category" id="category" bind:value={item.category}>
        <option value="כללי">כללי</option>
        {#each menuItemCategories as category}
          <option value={category}>{category}</option>
        {/each}
      </select>
    </div>

    <div class="itemOptions">
      <label>
        מנה צמחונית
        <input
          type="checkbox"
          bind:checked={item.isVegeterian}
          on:change={(e) => {
            if (e.target.checked) item.isVegan = false;
          }}
        />
      </label>
      <label>
        מנה טבעונית
        <input
          type="checkbox"
          bind:checked={item.isVegan}
          on:change={(e) => {
            if (e.target.checked) item.isVegeterian = false;
          }}
        />
      </label>
      <label>
        מנה חריפה
        <input
          type="checkbox"
          bind:checked={item.isSpicy}
          on:change={(e) => {
            if (e.target.checked) item.isVerySpicy = false;
          }}
        />
      </label>
      <label>
        מנה חריפה מאוד
        <input
          type="checkbox"
          bind:checked={item.isVerySpicy}
          on:change={(e) => {
            if (e.target.checked) item.isSpicy = false;
          }}
        />
      </label>
    </div>

    <!--options-->
    <div class="formSection">
      <div class="sectionTitle">
        אפשרויות
        <div class="dottedLine" />
        <div class="addBtn" on:click={addOption}>+</div>
      </div>
      {#if item.options}
        <div class="formItem">
          <div class="checkboxes">
            {#each item.options as optionsSection, sectionIdx}
              <div class="formItem">
                <div class="checkboxTitle">
                  <div
                    class="removeItem"
                    on:click={() => {
                      removeOption(sectionIdx);
                    }}
                  >
                    -
                  </div>
                  <div class="upDownBtns">
                    <div
                      class="btn"
                      on:click={() => {
                        moveOptionsSectionUp(sectionIdx);
                      }}
                    >
                      <TiArrowSortedUp />
                    </div>
                    <div
                      class="btn"
                      on:click={() => {
                        moveOptionsSectionDown(sectionIdx);
                      }}
                    >
                      <TiArrowSortedDown />
                    </div>
                  </div>
                  <input
                    type="text"
                    placeholder="ללא כותרת"
                    bind:value={optionsSection.name}
                    on:input={() => {
                      validateOptionsName(optionsSection);
                    }}
                    class:error={optionsSection.error}
                  />
                  <div
                    class="addItem"
                    on:click={() => {
                      addOptionItem(sectionIdx);
                    }}
                  >
                    +
                  </div>
                  {#if optionsSection.error}
                    <span class="errorLabel">{optionsSection.error}</span>
                  {/if}
                </div>
                <div class="optionOptions">
                  {#each optionsSection.items as option, optionIdx}
                    <div class="optionDetails">
                      {#if optionsSection.items.length > 1}
                        <div
                          class="removeItem"
                          on:click={() => {
                            removeOptionItem(sectionIdx, optionIdx);
                          }}
                        >
                          -
                        </div>
                      {/if}
                      <div class="upDownBtns">
                        <div
                          class="btn"
                          on:click={() => {
                            moveOptionUp(sectionIdx, optionIdx);
                          }}
                        >
                          <TiArrowSortedUp />
                        </div>
                        <div
                          class="btn"
                          on:click={() => {
                            moveOptionDown(sectionIdx, optionIdx);
                          }}
                        >
                          <TiArrowSortedDown />
                        </div>
                      </div>
                      <input
                        bind:value={option.label}
                        on:input={() => {
                          validateLabel(option, optionsSection);
                        }}
                        class:error={option.error}
                      />
                      <input
                        type="number"
                        class="priceVar"
                        bind:value={option.priceVar}
                      />
                      <div class="curr">₪</div>
                      {#if option.error}
                        <span class="errorLabel">{option.error}</span>
                      {/if}
                    </div>
                  {/each}
                </div>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>

    <!--checkboxes-->
    <div class="formSection">
      <div class="sectionTitle">
        תיבות סימון
        <div class="dottedLine" />
        <div class="addBtn" on:click={addCheckboxSection}>+</div>
      </div>
      {#if item.checkboxes}
        <div class="checkboxes">
          {#each item.checkboxes as checkboxSection, sectionIdx}
            <div class="formItem">
              <div class="checkboxSectionTitle">
                <div
                  class="removeItem"
                  on:click={() => {
                    removeCheckboxSection(sectionIdx);
                  }}
                >
                  -
                </div>
                <div class="upDownBtns">
                  <div
                    class="btn"
                    on:click={() => {
                      moveCheckboxSectionUp(sectionIdx);
                    }}
                  >
                    <TiArrowSortedUp />
                  </div>
                  <div
                    class="btn"
                    on:click={() => {
                      moveCheckboxSectionDown(sectionIdx);
                    }}
                  >
                    <TiArrowSortedDown />
                  </div>
                </div>
                <input
                  type="text"
                  bind:value={checkboxSection.name}
                  on:input={() => {
                    validateCheckboxesName(checkboxSection);
                  }}
                  class:error={checkboxSection.error}
                />
                <div
                  class="addItem"
                  on:click={() => {
                    addCheckbox(sectionIdx);
                  }}
                >
                  +
                </div>
                <span class="maxSelect">מקס' אפשרויות לבחירה</span>
                <input
                  type="number"
                  bind:value={checkboxSection.maxSelect}
                  class="priceVar"
                  min="0"
                />
                {#if checkboxSection.error}
                  <span class="errorLabel">{checkboxSection.error}</span>
                {/if}
              </div>
              <div class="checkboxOptions">
                {#each checkboxSection.items as checkbox, itemIdx}
                  <div class="checkboxDetails">
                    {#if checkboxSection.items.length > 1}
                      <div
                        class="removeItem"
                        on:click={() => {
                          removeCheckbox(sectionIdx, itemIdx);
                        }}
                      >
                        -
                      </div>
                    {/if}
                    <div class="upDownBtns">
                      <div
                        class="btn"
                        on:click={() => {
                          moveCheckboxUp(sectionIdx, itemIdx);
                        }}
                      >
                        <TiArrowSortedUp />
                      </div>
                      <div
                        class="btn"
                        on:click={() => {
                          moveCheckboxDown(sectionIdx, itemIdx);
                        }}
                      >
                        <TiArrowSortedDown />
                      </div>
                    </div>
                    <input
                      type="text"
                      bind:value={checkbox.label}
                      on:input={() => {
                        validateLabel(checkbox, checkboxSection);
                      }}
                      class:error={checkbox.error}
                    />
                    <input
                      class="priceVar"
                      type="number"
                      bind:value={checkbox.priceVar}
                    />
                    <div class="curr">₪</div>

                    <span class="maxSelect">מקס'</span>
                    <input
                      class="priceVar"
                      type="number"
                      bind:value={checkbox.maxSelect}
                      min="0"
                    />
                    {#if checkbox.error}
                      <span class="errorLabel">{checkbox.error}</span>
                    {/if}
                  </div>
                {/each}
              </div>
            </div>
          {/each}
        </div>
      {/if}
    </div>
    <div class="buttons">
      <button
        class="save"
        disabled={hasErrors}
        on:click|preventDefault={async () => {
          validateAll();
          if (!hasErrors) dispatch('save', item);
        }}
      >שמירה</button>
      <button class="cancel" on:click={pop}>ביטול</button>
    </div>
  </div>
</main>

<style>
  .itemOptions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 35px;
    font-size: 16px;
    margin: 12px 10px;
    padding: 16px;
    border-radius: 8px;
    align-items: center;
    background: #f4f4f4;
  }
  .category {
    display: flex;
    align-items: center;
  }

  .category > label {
    font-size: 20px;
  }
  .category > select {
    margin: 8px;
    font-size: 15px;
    border-radius: 4px;
    min-width: 100px;
  }
  .upDownBtns {
    display: flex;
    margin-right: -5px;
    margin-left: 5px;
    color: var(--grey1);
  }

  .upDownBtns > div {
    width: 26px;
    height: 26px;
  }

  .dottedLine {
    width: 100%;
    height: 0px;
    border-top: 3.5px dotted var(--grey1);
    padding-left: 10px;
    box-sizing: border-box;
    margin-left: 10px;
    margin-right: 10px;
  }
  .title {
    display: flex;
    align-items: center;
  }

  .title > input:nth-child(1) {
    width: -webkit-fill-available;
  }

  .maxSelect {
    margin-right: 20px;
    font-size: 12px;
  }
  .desc {
    width: 100%;
  }
  .checkboxSectionTitle {
    display: flex;
    align-items: center;
  }
  .checkboxOptions,
  .optionOptions {
    margin-right: 32px;
  }

  .checkboxDetails {
    display: flex;
    align-items: center;
  }

  .buttons {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    gap: 5px;
  }

  button,
  button {
    color: white;
    outline: none;
    border: none;
    padding: 10px;
    font-size: 16px;
    width: 50%;
    border-radius: 3px;
    cursor: pointer;
  }
  .save,
  .save:active {
    background: var(--green1);
  }

  .save:disabled {
    background: gray;
    cursor: default;
  }

  .cancel,
  .cancel:active {
    background: var(--red1);
  }
  main {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  input {
    margin-top: 5px;
    outline: none;
    border: 2px solid #e6e6e6;
    padding: 5px;
    font-size: 12px;
    border-radius: 10px;
  }

  input:focus {
    border: 2px solid black;
  }
  .form {
    min-width: 480px;
    width: 100%;
    max-width: 560px;
    background: white;
    direction: rtl;
    padding: 18px;
    border-radius: 3px;
    box-shadow: 0 20px 25px -20px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
  }

  .formSection {
    display: flex;
    align-items: center;
    padding: 5px;
    flex-wrap: wrap;
  }

  .sectionTitle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    white-space: nowrap;
    /* background: var(--blue1); */
    color: var(--grey1);
    padding: 6px 8px;
    border-radius: 35px;
    /* color: white; */
    min-height: 46px;
    padding-right: 22px;
    box-sizing: border-box;
  }

  .formItem {
    padding: 5px 0 0 5px;
    width: 100%;
  }

  .addBtn {
    background: var(--blue1);
    display: inline-flex;
    width: 30px;
    height: 30px;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 50px;
    border: 3px solid white;
    min-width: 30px;
  }

  .checkboxTitle {
    display: flex;
    align-items: center;
  }

  .priceVar {
    width: 50px;
    border-radius: 10px;
    margin-right: 7px;
  }

  .optionDetails {
    display: flex;
    align-items: center;
  }

  .addItem {
    width: 20px;
    height: 20px;
    background: var(--blue1);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 100px;
    margin-right: 10px;
    font-size: 14px;
  }

  .removeItem {
    width: 20px;
    height: 20px;
    background: var(--red1);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 100px;
    margin-right: 5px;
    margin-left: 10px;
    font-size: 14px;
    line-height: 14px;
  }

  .curr {
    font-size: 20px;
    margin-right: 5px;
  }

  .error,
  input:focus.error {
    border: 1px solid var(--red1);
  }

  .errorLabel {
    color: var(--red1);
    margin-right: 10px;
  }

</style>
